module.exports = __webpack_public_path__ + "static/media/m-ddamiNemo.819076e0.png";